import React, { useState } from 'react';
import { Popup, PopupPosition } from 'react-vant';
import { readLandingSearchParams } from '../../utils/landingPage';
import area from '../m_city_picker/area.json';
interface Props {
  currentProvince?: string; //当前位置省份

  position?: PopupPosition;
  height?: number | string;
  activeProvince?: string; //选中省份
  onClose: () => void;
  onConfirm: (v?:any) => void;
}
export default function ProvinceDialog({
  currentProvince,
  activeProvince,
  position,
  height,
  onClose,
  onConfirm,
}: Props) {

  const [receiverAddress, setreceiverAddress] = useState<string | undefined>(activeProvince || '');
  const [procincesValue, setprocincesValue] = useState<string | undefined>('');

  
  const handleConfirm = () => {
   const queryParams = readLandingSearchParams();
    let param = {
      ...queryParams,
      receiverAddress,
      pageNum: 1,
     
    };
    sessionStorage.setItem('searchParams', JSON.stringify(param));
    onConfirm(receiverAddress);
  };
 

  // 省份数据调整-将获取ip地址省份排列第一个
  const provinceArea = [...area];
  let index: any = currentProvince && provinceArea.findIndex((item) => item.label.includes(currentProvince));
  if (index !== -1) {
    let itemToMove = provinceArea.splice(index, 1)[0];
    itemToMove && provinceArea.unshift(itemToMove);
  }
  let areaOptions = provinceArea.map((item) => ({
    value: item?.label,
    label: item?.label.includes('黑龙江') ? '黑龙江' : item?.label.substring(0, 2),
  }));
  if (procincesValue) {
    areaOptions = areaOptions.filter((item) => item.value.includes(procincesValue));
  }
  return (
    <Popup
      visible
      style={{
        height: height || '80%',
        borderRadius: '16px 16px 0 0',
      }}
      position={(position || 'bottom') || "bottom"}
    >
      <div className="d-flex-c bh-100 screen-dialog">
        <div className="h-50 d-flex-r ai-center jc-between pl-12 pr-12">
          <span className="font-size-14 text-color-3" onClick={onClose}>
            取消
          </span>
       
          <span className="font-size-18 font-widget-600">收货地筛选</span>
          <span className="font-size-14 text-color-3" onClick={handleConfirm}>
            确定
          </span>
        </div>

        {/* 右侧内容区域 - 可滚动 */}
        <div className="flex-1 overflow-y">



          <div id="section-area" className="line-height-40 pl-12 pr-12 mb-10">
            <div className="d-flex-r ai-center jc-between">

              <div className="d-flex-r ai-center">
                {currentProvince && (
                  <div className="font-size-12 text-color-6 mr-10">当前位置：{currentProvince}</div>
                )}

              </div>
            </div>
            <div className="search-ipt-block border d-flex-r bg-white pl-10 pr-3 pt-5 pb-5 m-10 border-radius-8 pos-r">
                  <input
                    className="input-block flex-1"
                    type="text"
                    placeholder="输入省份搜索"
                    value={procincesValue}
                    onChange={(v) => {
                      setprocincesValue(v.target.value);
                    }}
                  />
                 
                </div>
            <div className="d-flex-r ai-center flex-wrap">
              {areaOptions.map((item, idx) => (
                <div
                  className="area-tag"
                  key={idx}
                  onClick={() => {
                    setreceiverAddress(item.label === receiverAddress ? '' : item.label);
                   
                  }}
                >
                  {idx === 0 && (
                    <div
                      className={`bg-gray mr-5 mb-5 text-color-3 text-center d-flex-r ai-center jc-center ${item.label === receiverAddress && 'active'
                        }`}
                    >
                      <img className="w-14 mr-2" src="/pic/icon_position.png" alt="" />
                      <span>{item.label}</span>
                    </div>
                  )}
                  {idx > 0 && (
                    <div
                      className={`bg-gray mr-5 mb-5 text-color-3 text-center ${item.label === receiverAddress && 'active'
                        }`}
                    >
                      {item.label}
                    </div>
                  )}





                </div>
              ))}
            </div>


          </div>
        </div>
        {/* 底部操作区 */}
        {/* <div className="h-50 p-8 d-flex-r ai-center">
          <button onClick={handleClear} className="flex-1 mr-12 cancel-btn btn">
            清空筛选
          </button>
          <button onClick={handleConfirm} className="flex-1 confirm-btn btn bg-p text-color-white">
            确定
          </button>
        </div> */}
      </div>
    </Popup>
  );
}
